import type { PvSelfConsumptionWidget } from '../../../widgets';
import {
  BindingRow,
  OptionalBindingRow,
  Section,
  patcher,
  type WidgetEditorProps,
} from '../fields';
import { AiHintSection } from './AiHintSection';

export function PvSelfConsumptionEditor(
  { widget, plantId, onChange }: WidgetEditorProps<PvSelfConsumptionWidget>,
) {
  const patch = patcher(widget, onChange);
  return (
    <>
      <Section title="Leistung">
        <BindingRow
          label="PV-Erzeugung"
          value={widget.pvPowerPoint}
          plantId={plantId}
          filter={{ valueType: 'number' }}
          onChange={(next) => patch({ pvPowerPoint: next })}
        />
        <OptionalBindingRow
          label="Hausverbrauch"
          value={widget.householdPowerPoint}
          plantId={plantId}
          filter={{ valueType: 'number' }}
          onChange={(next) => patch({ householdPowerPoint: next })}
        />
        <OptionalBindingRow
          label="Netz"
          value={widget.gridPowerPoint}
          plantId={plantId}
          filter={{ valueType: 'number' }}
          hint="Positiv ist Einspeisung, negativ ist Bezug. Die Kachel färbt beide Richtungen verschieden."
          onChange={(next) => patch({ gridPowerPoint: next })}
        />
      </Section>

      <Section title="Batterie">
        <OptionalBindingRow
          label="Ladestand"
          value={widget.batterySocPoint}
          plantId={plantId}
          filter={{ valueType: 'number' }}
          onChange={(next) => patch({ batterySocPoint: next })}
        />
        <OptionalBindingRow
          label="Lade- und Entladeleistung"
          value={widget.batteryPowerPoint}
          plantId={plantId}
          filter={{ valueType: 'number' }}
          hint="Positiv heißt laden."
          onChange={(next) => patch({ batteryPowerPoint: next })}
        />
      </Section>

      <Section title="Tagessummen" hint="Energie in kWh, nicht Leistung.">
        <OptionalBindingRow
          label="Erzeugung"
          value={widget.dailyProductionEnergyPoint}
          plantId={plantId}
          filter={{ valueType: 'number' }}
          onChange={(next) => patch({ dailyProductionEnergyPoint: next })}
        />
        <OptionalBindingRow
          label="Eigenverbrauch"
          value={widget.dailySelfUseEnergyPoint}
          plantId={plantId}
          filter={{ valueType: 'number' }}
          onChange={(next) => patch({ dailySelfUseEnergyPoint: next })}
        />
        <OptionalBindingRow
          label="Einspeisung"
          value={widget.dailyFeedInEnergyPoint}
          plantId={plantId}
          filter={{ valueType: 'number' }}
          onChange={(next) => patch({ dailyFeedInEnergyPoint: next })}
        />
        <OptionalBindingRow
          label="Netzbezug"
          value={widget.dailyGridDrawEnergyPoint}
          plantId={plantId}
          filter={{ valueType: 'number' }}
          onChange={(next) => patch({ dailyGridDrawEnergyPoint: next })}
        />
      </Section>

      <AiHintSection value={widget.ai} onChange={(next) => patch({ ai: next })} />
    </>
  );
}
